"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.VARIANTS = void 0;
var _styledComponents = require("styled-components");
var _spinner = _interopRequireDefault(require("./spinner"));
var _theme = _interopRequireDefault(require("../theme"));
var _focus = require("./focus");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var VARIANTS = exports.VARIANTS = /*#__PURE__*/function (VARIANTS) {
  VARIANTS["primary"] = "primary";
  VARIANTS["secondaryOutline"] = "secondaryOutline";
  VARIANTS["secondaryOutlineTransparent"] = "secondaryOutlineTransparent";
  VARIANTS["tertiary"] = "tertiary";
  VARIANTS["tertiaryTransparent"] = "tertiaryTransparent";
  VARIANTS["primaryDark"] = "primaryDark";
  return VARIANTS;
}({});
var variantColors = {
  primary: {
    color: '#FFF',
    hoverColor: _theme["default"].textColor,
    bgColor: _theme["default"].indigo60,
    hoverBgColor: _theme["default"].indigo30,
    activeBgColor: '#283297'
  },
  secondaryOutline: {
    color: _theme["default"].indigo60,
    hoverColor: _theme["default"].indigo80,
    borderColor: _theme["default"].indigo60,
    hoverBgColor: _theme["default"].indigo30,
    activeBgColor: '#283297',
    hoverBorderWidth: 2
  },
  secondaryOutlineTransparent: {
    color: '#FFF',
    hoverColor: _theme["default"].indigo80,
    bgColor: 'transparent',
    borderColor: '#FFF',
    hoverBgColor: _theme["default"].indigo30,
    hoverBorderBgColor: _theme["default"].indigo30
  },
  tertiary: {
    color: _theme["default"].textColor,
    bgColor: _theme["default"].teal60,
    hoverBgColor: '#cef8ec',
    activeBgColor: '#33c196'
  },
  tertiaryTransparent: {
    color: _theme["default"].indigo60
  },
  primaryDark: {
    color: _theme["default"].textColor,
    bgColor: _theme["default"].yellow100,
    hoverBgColor: '#fcfbc8',
    activeBgColor: '#cfca1c'
  }
};
var getFilledVariant = function getFilledVariant(_ref) {
  var color = _ref.color,
    hoverColor = _ref.hoverColor,
    bgColor = _ref.bgColor,
    hoverBgColor = _ref.hoverBgColor,
    activeBgColor = _ref.activeBgColor;
  return (0, _styledComponents.css)(["color:", ";background-color:", ";border-color:", ";&:hover,&:focus{color:", ";background-color:", ";border-color:", ";}&:active{color:", ";background-color:", ";border-color:", ";transform:scale(0.98);}"], color, bgColor, bgColor, hoverColor || color, hoverBgColor, hoverBgColor, color, activeBgColor, activeBgColor);
};
var getOutlineTransparentVariant = function getOutlineTransparentVariant(_ref2) {
  var bgColor = _ref2.bgColor,
    color = _ref2.color,
    borderColor = _ref2.borderColor,
    hoverColor = _ref2.hoverColor,
    hoverBorderBgColor = _ref2.hoverBorderBgColor,
    hoverBgColor = _ref2.hoverBgColor;
  return (0, _styledComponents.css)(["color:", ";background-color:", ";border-color:", ";&:hover,&:focus,&:active{color:", ";background-color:", ";border-color:", ";}&:active{transform:scale(0.98);}"], color, bgColor, borderColor, hoverColor, hoverBgColor, hoverBorderBgColor);
};
var getOutlineVariant = function getOutlineVariant(_ref3) {
  var color = _ref3.color,
    borderColor = _ref3.borderColor,
    activeBgColor = _ref3.activeBgColor,
    hoverBgColor = _ref3.hoverBgColor,
    hoverColor = _ref3.hoverColor,
    hoverBorderWidth = _ref3.hoverBorderWidth;
  return (0, _styledComponents.css)(["color:", ";background-color:transparent;border-color:", ";&:hover,&:focus,&:active{color:", ";border-color:", ";background-color:", ";box-shadow:inset 0 0 0 ", "px ", ";}&:active{transform:scale(0.98);}"], color, borderColor, hoverColor, activeBgColor, hoverBgColor, hoverBorderWidth / 2 || 0, activeBgColor);
};
var getNoOutlineTransparentVariant = function getNoOutlineTransparentVariant(_ref4) {
  var color = _ref4.color;
  return (0, _styledComponents.css)(["color:", ";background-color:transparent;border:none;width:max-content;&:hover,&:focus,&:active{text-decoration:underline;outline:none;}"], color);
};
var styleVariants = {
  primary: getFilledVariant(variantColors.primary),
  secondaryOutline: getOutlineVariant(variantColors.secondaryOutline),
  secondaryOutlineTransparent: getOutlineTransparentVariant(variantColors.secondaryOutlineTransparent),
  tertiary: getFilledVariant(variantColors.tertiary),
  tertiaryTransparent: getNoOutlineTransparentVariant(variantColors.tertiaryTransparent),
  primaryDark: getFilledVariant(variantColors.primaryDark),
  disabled: (0, _styledComponents.css)(["&,&:hover,&:active{color:", ";background-color:#f0f0f5;border-color:#f0f0f5;}"], _theme["default"].greyishBrown)
};
var getVariant = function getVariant(props) {
  return styleVariants[props.variant];
};
var buttonStyles = (0, _styledComponents.css)(["position:relative;box-sizing:border-box;display:flex;justify-content:center;align-items:center;min-height:48px;width:100%;margin:0;padding:0 ", ";border-radius:", ";font-family:", ";font-size:1.6rem;font-weight:bold;color:white;border-width:1px;border-style:solid;text-align:center;line-height:normal;white-space:nowrap;transition:color 0.2s ease-in-out,border-color 0.2s ease-in-out,background 0.2s ease-in-out,transform 0.1s ease-in-out,box-shadow 0.1s ease-in-out,outline 0.1s ease-in-out,outline-offset 0.1s ease-in-out;user-select:none;cursor:pointer;&,&:hover{text-decoration:none;}", ";&[disabled]{cursor:auto;pointer-events:none;&:active{transform:none;}}", " ", " ", " ", ""], _theme["default"].space30, _theme["default"].radii.borderRadius30, _theme["default"].buenosAires, _focus.focusStyles, _theme["default"].mediaMediumPlus(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      width: auto;\n      padding: 0 ", ";\n      "])), _theme["default"].space60), function (_ref5) {
  var sizeMediaMediumUp = _ref5.sizeMediaMediumUp;
  return sizeMediaMediumUp === 'fullWidth' && (0, _styledComponents.css)(["", ""], _theme["default"].mediaMediumPlus(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        width: 100%;\n        padding: 0 ", ";\n      "])), _theme["default"].space30));
}, getVariant, function (_ref6) {
  var loading = _ref6.loading;
  return loading && (0, _styledComponents.css)(["pointer-events:none;color:transparent;&:before{position:absolute;content:'';", ";}"], _spinner["default"]);
});
var _default = exports["default"] = buttonStyles;